import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sensor-setting',
  templateUrl: './sensor-setting.component.html',
  styleUrls: ['./sensor-setting.component.less']
})
export class SensorSettingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
